import { NOTIFICATION_SECTION } from "../constants";
import { isUnread } from "./notificationModel";

const byNewestFirst = (a, b) => b.createdAtMs - a.createdAtMs;

export function splitByReadState(notifications = []) {
  return notifications.reduce(
    (acc, notification) => {
      if (isUnread(notification)) {
        acc.unread.push(notification);
      } else {
        acc.read.push(notification);
      }
      return acc;
    },
    { unread: [], read: [] },
  );
}

export function buildNotificationSections(notifications = []) {
  const { unread, read } = splitByReadState(notifications);

  const sections = [];

  if (unread.length > 0) {
    sections.push({
      id: NOTIFICATION_SECTION.NEW,
      items: [...unread].sort(byNewestFirst),
    });
  }

  if (read.length > 0) {
    sections.push({
      id: NOTIFICATION_SECTION.OLDER,
      items: [...read].sort(byNewestFirst),
    });
  }

  return sections;
}
